import { createContext } from "react";
const context = createContext();
export const { Provider } = context;
export default context;